import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

import MakeBookingPage from "../components/MakeBooking";
import { fetch as fetchDrivers } from "../store/actions/drivers-actions";
import { fetch as fetchVehicles } from "../store/actions/vehicles-actions";
import classes from "../components/auth/RegistrationStatus.module.scss";

const now = moment();
const startTime = moment("06:00", "HH:mm");
const endTime = moment("17:00", "HH:mm");

const isBookingTime = now.isBetween(startTime, endTime);

const deliveryZoneOptions = {
  regular: [
    { label: "Green", value: "GREEN" },
    { label: "Blue", value: "BLUE" },
  ],
  forMilkRun: [
    { label: "Milk Run starting from Green", value: "GREEN" },
    { label: "Milk Run starting from Blue", value: "BLUE" },
  ],
};

export default function MakeBooking() {
  const dispatch = useDispatch();

  const cargoTypeOptions = useSelector(
    (state) => state.options.cargoTypeOptions
  );
  const driverOptions = useSelector((state) => state.drivers.options);
  const vehicleOptions = useSelector((state) => state.vehicles.options);

  useEffect(() => {
    dispatch(fetchDrivers());
    dispatch(fetchVehicles());
  }, [dispatch]);

  return (
    <>
      {isBookingTime ? (
        <MakeBookingPage
          cargoTypeOptions={cargoTypeOptions}
          vehicleOptions={vehicleOptions}
          driverOptions={driverOptions}
          deliveryZoneOptions={deliveryZoneOptions}
        />
      ) : (
        <div className={classes.container}>
          <div className={classes.message}>
            Booking is unavailable at this time. Our booking hours are from{" "}
            {startTime.format("HH:mm")} to {endTime.format("HH:mm")}.
          </div>
        </div>
      )}
    </>
  );
}
